/**
 * システム定数定義
 */
export default class SystemConstants {
    /** システム名 */
    static readonly SYSTEM_NAME = "食品検査システム"
    /** 会社名 */
    static readonly COPYRIGHT_NAME = "メリューニュートリサイエンシズジャパン株式会社"
    /** COPYRIGHTの開始年 */
    static readonly COPYRIGHT_START_YEAR = 2020
}